import { FelaCSS } from '../../../../components/fela/flowtypes';
import { SharedTypes as PropTypes } from './radio-toggle-wrap-v2';

interface StypeTypes {
  wrapper: FelaCSS;
  input: FelaCSS;
  label: FelaCSS;
}

const styles = ({ disabled, block }: PropTypes): StypeTypes => ({
  wrapper: {
    position: 'relative',
    display: block ? 'block' : 'flex',
    width: block ? 'fit-content' : '100%',
  },

  input: {
    position: 'absolute',
    visibility: 'hidden',
  },

  label: disabled
    ? {
        pointerEvents: 'none',
        cursor: 'default',
      }
    : {
        cursor: 'pointer',
      },
});

export default styles;
